'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _nuiIntl = require('@concur/nui-intl');

!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require('./style/MiniListing.css') : void 0;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://eng.wealthfront.com/2015/06/30/implementing-netflix-redesign/
// If we want slide: http://codepen.io/dangvanthanh/pen/BsDbg
// more slide: http://jsfiddle.net/jkneb/9uRKt/
var MiniListing = function MiniListing(_ref) {
  var listing = _ref.listing,
      isLoggedIn = _ref.isLoggedIn;
  var miniImage = listing.images.miniImage,
      _listing$localized = listing.localized,
      name = _listing$localized.name,
      summary = _listing$localized.summary,
      title = _listing$localized.title,
      _listing$core = listing.core,
      isUserConnected = _listing$core.isUserConnected,
      icon = _listing$core.icon;


  return _react2.default.createElement(
    'div',
    { className: 'mini-listing' },
    _react2.default.createElement('img', {
      src: icon || miniImage || 'https://www.concursolutions.com/static/images/brand/logo-SAPConcur-20171204.svg',
      className: 'card-image',
      alt: name + ' icon'
    }),
    _react2.default.createElement(
      'div',
      { className: 'card-text card-title' },
      name
    ),
    !isUserConnected ? _react2.default.createElement(
      'div',
      { className: 'card-text card-headline' },
      title
    ) : null,
    isLoggedIn && isUserConnected ? _react2.default.createElement(
      'span',
      { className: 'is-connected-check' },
      _react2.default.createElement('span', { className: 'is-connected-check-details icon-check icon-size-sm' }),
      '\xA0',
      _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'Connected' })
    ) : null,
    _react2.default.createElement(
      'div',
      { className: 'overlay' },
      summary
    )
  );
};

MiniListing.propTypes = {
  listing: _propTypes2.default.object.isRequired,
  isLoggedIn: _propTypes2.default.bool
};

exports.default = MiniListing;


//////////////////
// WEBPACK FOOTER
// ./lib/shared/MiniListing.js
// module id = 571
// module chunks = 0